import * as React from "react";
import {useTranslation} from "react-i18next";
import {useCheckoutContext} from "../../CheckoutContextProvider/CheckoutContextProvider";
import "./AnnotationBlock.scss";

export default function AnnotationBlock() {
  const {t} = useTranslation("checkout");
  const checkout = useCheckoutContext().checkout;

  const handleBlur = async (e) => {
    await checkout.put({customerRemark: e.target.value});
  };

  return (
    <>
      <h2>{t("Anmerkungen")}</h2>
      <div className="Annotation">
        <textarea
          onBlur={handleBlur}
          defaultValue={checkout.customerRemark || undefined}
          rows={1}
          placeholder={t("Anmerkungen hinzufügen (optional)")}
        />
      </div>
    </>
  );
}
